import { ENV } from "../utils";

export class Industry {
  baseApi = ENV.BASE_API;

  async getIndustries(accessToken, active = true) {
    const url = `${this.baseApi}/industries?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createIndustry(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-industry`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateIndustry(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-industry/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteIndustry(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-industry/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
